import React, { useEffect, useState, useCallback } from "react";
import Pagination from "../Pagination/Pagination";
import nftDetailsStyles from "./scss/nft-details.module.scss";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllItemSort, getPayload } from "../../store/actions";
import endPoints from "../../store/utils/endPoints";
import TableSkeleton from "../Loader/TableSkeleton";
import { numberWithCommas } from "../../utils/misc";
import { isEqual } from "lodash";

const NFTs = ({ timeFrame }) => {
  const dispatch = useDispatch();
  const { topNft } = useSelector((state) => state.nft);
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [queryParams, setQueryParams] = useState({});

  useEffect(() => {
    if (!topNft) {
      dispatch(
        getPayload(`${endPoints.allNft}`, {
          ...queryParams,
          range: timeFrame,
          // page: pageNo,
        })
      );
    }
  }, [timeFrame]);

  useEffect(() => {
    if (topNft && topNft.message) {
      dispatch(
        AllItemSort(
          endPoints.allNft,
          [...topNft.message],
          sortField,
          sortType || false
        )
      );
    }
  }, [queryParams]);

  const handleSortChange = (field, type) => {
    setSortField(field);
    setSortType(type);
    setQueryParams({
      range: timeFrame,
      [field]: type,
    });
  };

  const changePage = useCallback(
    (value) => {
      setPageNo(value);
    },
    [pageNo]
  );

  return (
    <>
      <table className={nftDetailsStyles.table}>
        <thead>
          <tr>
            <th>NFT Details</th>
            <th
              onClick={() =>
                handleSortChange(
                  "nft_attribute",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              <img
                className="coin-sign opacity-0"
                src="img/ethereum-sign.png"
                alt=""
              />
              Attributes{" "}
              <i
                className={`fa-solid ${sortField === "nft_attribute"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th>Owner</th>
            <th
              onClick={() =>
                handleSortChange(
                  "last_price",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Last Price ({timeFrame}){" "}
              <i
                className={`fa-solid ${sortField === "last_price"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "highest_price",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Highest Price ({timeFrame}){" "}
              <i
                className={`fa-solid ${sortField === "highest_price"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("sales", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Sales ({timeFrame}){" "}
              <i
                className={`fa-solid ${sortField === "sales"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th>Last Deal</th>
          </tr>
        </thead>
        <tbody>
          {!topNft ? (
            <TableSkeleton colSpan={7} />
          ) : (
            topNft.message.map((element) => (
              <tr>
                <td className="border-right 2px ">
                  <div className="mr-3">
                    <img
                      height={"30px"}
                      width={"30px"}
                      src={element?.image || ""}
                      alt=""
                    />
                  </div>
                  <label>
                    <Link to={`/nft/${element.contract_address}`} >{element?.name}</Link>
                    <span>{element?.type}</span>
                  </label>
                </td>
                <td
                  className="data-highlight"
                  title={element?.attributes.map((e) => e.value).join(", ")}
                >
                  <img
                    className="coin-sign"
                    src="img/ethereum-sign.png"
                    alt=""
                  />
                  {element?.attributes
                    .map((e) => e.value)
                    .join(", ")
                    .substring(0, 25)}
                </td>
                <td className="data-highlight" title={element.owners ? element.owners : ''}>
                  {(element.owners && element.owners.slice(0, 9)) +
                    "..." +
                    (element.owners && element.owners.slice(-4))}
                </td>
                <td>{element.lowest_price && element.lowest_price}</td>
                <td>{element.highest_price && element.highest_price}</td>
                <td>
                  {element.sales ? numberWithCommas(+element.sales) : "N/A"}
                </td>
                <td>{element?.last_deal || "N/A"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {/* {topNft && (
        <Pagination
          totalPages={Math.ceil(topNft.total / topNft.page_size)}
          setPage={changePage}
        />
      )} */}
    </>
  );
};

export default React.memo(NFTs, isEqual);
